import React from 'react'

import { setLevelsOnPlaceRoot } from '../../_data/setLevelsOnPlaceRoot'
import { usePlaces } from '../_load/PlacesLoader'

export const useFormattedPlacesForTable = () => {
  const places = usePlaces()
  return React.useMemo(() => places.map(setLevelsOnPlaceRoot), [places])
}
